<template>
  <ul class="b2b-color-selector">
    <li v-for="(color, index) in colors" :key="index" class="b2b-color-selector__list-item">
      <label :for="`b2b-color-swatch-${color}`" class="b2b-color-selector__label">
        <input
          :id="`b2b-color-swatch-${color}`"
          v-model="active"
          type="radio"
          :aria-label="`${color} swatch`"
          class="b2b-color-selector__color-check"
          :data-color="color"
          data-id="#"
          data-url="#"
          :name="radioName"
          :value="color"
          @change="onChange"
        />

        <span class="b2b-color-selector__color-decorator" :class="`swatch-${color}`"> </span>
      </label>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    activeColor: {
      type: String,
      default: '',
    },
    colors: {
      type: Array,
      default: () => [],
    },
    radioName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      active: this.activeColor,
    };
  },
  methods: {},
};
</script>
